module.exports = __webpack_public_path__ + "img/room.703f6f35.svg";